import {defineStore} from "pinia";
import {ref} from "vue";
import {getAllUser} from "@/apis/UserApi";

// 用户列表
const userList = ref([])
// 用户Map key:id value:用户对象
const userIdMap = ref(new Map())

export const useUserDataStore = defineStore('userData', () => {
    // 初始化用户数据
    const initUserData = () => {
        getAllUser().then((res) => {
            userList.value = res.data || [];
            userIdMap.value = new Map(res.data?.map(item => [item.id, item]));
        });
    };
    
    return {
        // 初始化用户数据
        initUserData,
        userList,
        userIdMap
    }
})